import { formatCreateVenuePayload } from '../';
import { createVenue, ICreateVenueBody } from 'src/api/createVenue';
import { mapVenueToDetailsPage } from 'src/pages/Venue/mapVenueToDetailsPage/mapVenueToDetailsPage';
import { IVenueCreateFormValues } from '../../types';

const createVenueForm = async (data: IVenueCreateFormValues) => {
  const payload: ICreateVenueBody = formatCreateVenuePayload(data);
  const response = await createVenue(payload);
  if (!response.ok) {
    throw new Error(response.message);
  }

  const newVenue = await response.json();
  const formattedVenue = mapVenueToDetailsPage(newVenue.data[0]);

  return formattedVenue;
};

export default createVenueForm;
